import { PageData, PageDataParams } from './page-data';
import {
  Skill,
  PageType,
  RawPageData,
  RawSkillCompletionPageData,
} from '../common/page-data';

export class SkillCompletionData extends PageData {
  private _currentSkill: Skill;
  private _nextSkill: Skill;

  public get pageType(): PageType {
    return PageType.Banner;
  }

  public get currentSkill(): Skill {
    return this._currentSkill;
  }

  public get nextSkill(): Skill {
    return this._nextSkill;
  }

  public get rawData(): RawPageData {
    return this._rawPageData;
  }

  public constructor(params: PageDataParams) {
    super(params);

    const { rawPageData } = params;

    this._currentSkill = rawPageData.skill;
    this._nextSkill = (rawPageData as RawSkillCompletionPageData).nextSkill;
  }
}
